import { AgGridReact, AgGridColumn } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { useState } from "react";
import axios from "axios";
import { url, auth_key, user_id } from "../../constants";

const deleteData = async (cat, query, type) => {
  try {
    if (cat) {
      const response = await axios.post(
        `${url}deleteTest`,
        {
          headers: {
            "X-Api-Key": auth_key,
          },
          params: {
            User_ID: user_id,
          },
        },
        {
          Catagory: cat,
          Query: query,
          Type: type,
        }
      );
      return response.data;
    }
  } catch (error) {
    console.log(error);
  }
};

const SearchEngine = (props) => {
  const [rows, setRows] = useState(props.rows);
  const cat = props.cat;
  const [paramID, setParamID] = useState(null);
  return (
    <div
      style={{
        overflow: "scroll",
        width: 1000,
        height: "90vh",
      }}
      className="ag-theme-alpine invisible-scrollbar"
      onKeyDown={async (e) => {
        if (e.key === "Delete") {
          if (paramID.getSelectedRows().length > 0) {
            await deleteData(
              cat,

              paramID.getSelectedRows()[0].Query,
              "Seggestion"
            );
          }
        }
      }}
    >
      <AgGridReact
        defaultColDef={{
          sortable: true,
          filter: true,
        }}
        rowData={rows?.values}
        rowSelection="single"
        onGridReady={(params) => {
          setParamID(params.api);
        }}
      >
        {rows?.columns?.map((value) => {
          return (
            <AgGridColumn
              field={value}
              key={value}
              filter="agTextColumnFilter"
              width={value === "Results" ? 1000 : 200}
            />
          );
        })}
      </AgGridReact>
    </div>
  );
};

export default SearchEngine;
